import React, { FC, useEffect, useState } from 'react';
import { OzoneDrawer as Drawer } from 'components/atoms/drawer';
import {
  FilterableField,
  GroupedOptions,
} from 'components/organisms/tasks/fields';
import { GetFilterOperationTypeOptions } from 'components/organisms/tasks/filter-box/advanced';
import { Row } from 'components/organisms/tasks/filter-box/components';
import { FilterType } from 'components/organisms/tasks/filter-box/filter-type';
import { FieldFilter } from 'components/organisms/tasks/filters';
import { GroupedFilter } from 'components/organisms/tasks/grouped-filter-popover';
import { Footer } from './drawer-footer';
import { ContentHeader, FilterWrapper, GroupedFilterComponent } from './styles';

export const GroupedFDrawer: FC<{
  title?: string | React.ReactNode;
  header?: string | React.ReactNode;
  filter: GroupedFilter;
  onSubmit: (_filter: GroupedFilter) => void;
  visible: boolean;
  onClose: VoidFunction;
  fields: GroupedOptions<FilterableField>[];
  getFilterOperationTypeOptions?: GetFilterOperationTypeOptions;
}> = ({
  title,
  header,
  filter: _filter,
  onSubmit,
  visible,
  onClose,
  fields,
  getFilterOperationTypeOptions,
}) => {
  const [filter, setFilter] = useState(_filter);

  useEffect(() => {
    setFilter(_filter);
  }, [_filter]);

  const onDone = () => {
    const validCriteria = filter.groupCriteria.filter(({ criteria }) =>
      FieldFilter.isValid(criteria),
    );

    onSubmit({ ...filter, groupCriteria: validCriteria });
  };

  return (
    <Drawer
      title={title}
      width={880}
      visible={visible}
      onClose={onClose}
      footer={<Footer onClose={onClose} onDone={onDone} />}
    >
      <ContentHeader>
        <b>{header}</b>
        <Row>
          <FilterType
            value={filter.type}
            onChange={(type) => setFilter({ ...filter, type })}
          />
        </Row>
      </ContentHeader>
      <FilterWrapper>
        {visible && (
          <GroupedFilterComponent
            fields={fields}
            filter={filter}
            onChange={setFilter}
            getFilterOperationTypeOptions={getFilterOperationTypeOptions}
          />
        )}
      </FilterWrapper>
    </Drawer>
  );
};
